import { render, staticRenderFns } from "./newsPage13.vue?vue&type=template&id=5abdb2e0&scoped=true&"
import script from "./newsPage13.vue?vue&type=script&lang=js&"
export * from "./newsPage13.vue?vue&type=script&lang=js&"
import style0 from "./newsPage13.vue?vue&type=style&index=0&id=5abdb2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abdb2e0",
  null
  
)

export default component.exports